/**
 * Implements a KendoUI ComboBox as a Marionette Behavior.
 */

import Marionette from "backbone.marionette";

import "kendo.core";
import "kendo.data";
import "kendo.fx";
import "kendo.popup";
import "kendo.list";
import "kendo.combobox";

class ComboBox extends Marionette.Behavior {
  defaults() {
    return {
      // behavior defaults
      selector: ".rvc-combobox",
      opts: {
        autoWidth: true,
        placeholder: "",
        dataTextField: "text",
        dataValueField: "text",
        dataSource: [],
        filter: "contains",
        noDataTemplate: "No matches found",
      },
    };
  }

  initialize() {
    // merge defaults and user options
    _.defaults(this.options.opts, this.defaults.opts);
  }

  onRender() {
    // setup listener when required
    if (this.options.dataAttribute) {
      this.listenTo(
        this.view.model,
        `change:${this.options.dataAttribute}`,
        this.onModelChange
      );
    }

    // instantiate control
    const instance = this.$(this.options.selector).kendoComboBox(
      this.options.opts
    );

    // persist reference to its API
    this.api = instance.getKendoComboBox();
  }

  // custom method triggered by child views or by the listener defined above
  onModelChange(model) {
    // extract value from model
    const data = model.get(this.options.dataAttribute);
    if (data) {
      try {
        // create a Kendo DataSource
        const ds = new kendo.data.DataSource({
          // and set its data to that of the dataAttribute;
          // this must always be a Backbone collection.
          data: data.toJSON(),
        });
        // update the behavior's DataSource
        this.api.setDataSource(ds);
        this.api.enable(true);
      } catch (err) {
        console.error(err.stack);
      }
    } else {
      this.api.enable(false);
    }
  }
}

export { ComboBox as default };
